module.exports = __webpack_public_path__ + "static/img/11.6a0609c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/8/zh/11.png
// module id = ciW2
// module chunks = 0